export default "__VITE_ASSET__BPwB7uFk__"